import { render, staticRenderFns } from "./CatalogPagination.vue?vue&type=template&id=d7e0faa0&"
import script from "./CatalogPagination.vue?vue&type=script&lang=js&"
export * from "./CatalogPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports